export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/thumbnails.f3609f2.svg";